import React from 'react';
import {
  FieldComponentProps,
} from 'components/anvilFormFillable/fields/types';
import FormControl from '@mui/material/FormControl';
import MuiRadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { getStableKey } from 'components/anvilFormFillable/utils';

export default function RadioGroup({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  return (
    <div className="w-full overflow-hidden">
      <FormControl className="w-full">
        <MuiRadioGroup
          id={field?.id ?? ''}
          key={field.id}
          name={field?.name ?? ''}
          value={value?.value ?? ''}
          onChange={(event) => { onChange?.({ ...value, value: event.target.value }); }}
          className="!flex-row flex-nowrap overflow-x-auto space-x-2 w-full"
        >
          {field?.children?.map((child) => (
            <div key={getStableKey(child, field.id)} className="flex-shrink-0">
              <FormControlLabel
                className="w-full whitespace-nowrap"
                classes={{
                  label: 'text-sm',
                }}
                label={child?.name}
                control={(
                  <Radio
                    autoFocus={error && child === field?.children?.[0]}
                    className="w-max"
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: 16,
                      },
                    }}
                  />
                )}
                value={child?.id ?? ''}
              />
            </div>
          ))}
        </MuiRadioGroup>
      </FormControl>
    </div>
  );
}
